/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quantity: NonNullable<unknown>, unit: NonNullable<unknown>, price: NonNullable<unknown>, rate: NonNullable<unknown> }} Einvoice_Draft_Line_MetaInputs */

const vi_einvoice_draft_line_meta = /** @type {(inputs: Einvoice_Draft_Line_MetaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} ${i?.unit} × ${i?.price} đ · Thuế suất ${i?.rate}`)
};

/**

* @param {Einvoice_Draft_Line_MetaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_line_meta = /** @type {((inputs: Einvoice_Draft_Line_MetaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Line_MetaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_line_meta(inputs)
});